module.exports = __webpack_public_path__ + "img/23.b82cd213.jpg";